import { Modal, TextContainer } from '@shopify/polaris';
import React from 'react'

const PolarisModal = props => {

    return (
        <Modal
            title={props.modalTitle}
            open={props.active}
            large={props.large}
            onClose={props.handleClose}
            primaryAction={props.primaryAction !== null && props.primaryAction}
            secondaryActions={props.secondaryActions !== null && props.secondaryActions}
        >
            <Modal.Section>
                <TextContainer>
                    {props.component}
                </TextContainer>
            </Modal.Section>
        </Modal >

    );
}



export default PolarisModal;
